import SecureEndpoint from './secure-endpoint'
import { AxiosResponse } from 'axios'
import { TResponseType } from '../models'
import { clear } from 'console'

const readCart = (payload: {}): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().get('/api/v1/cart/')
}

const removeFromCart = (payload: { eventId: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().delete('/api/v1/cart/' + payload.eventId)
}

const addToCart = (payload: { eventId: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().post('/api/v1/cart/' + payload.eventId)
}

const checkout = (payload: {}): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().post('/api/v1/cart/checkout')
}

const getPurchases = (payload: {}): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().get('/api/v1/purchases/my/')
}

const clearCart = (): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().delete('/api/v1/cart/')
}

export const shopService = { readCart, removeFromCart, addToCart, clearCart, checkout, getPurchases }
